import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
    selector: 'app-filter-autocomplete',
    templateUrl: './filter-autocomplete.component.html',
    styleUrls: ['./filter-autocomplete.component.scss'],
    standalone: false
})
export class FilterAutocompleteComponent implements OnInit, OnChanges {

  @Input() label: string;
  @Input() options: any[];
  @Input() value: any;
  @Output() optionSelected;

  myControl = new UntypedFormControl();
  filteredOptions: Observable<any[]>;

  constructor(
  ) {
    this.optionSelected = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.initFilter();
  }

  initFilter() {
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options) {
      this.options = changes.options.currentValue;
      if (!this.options.length) {
        this.myControl.disable();
      } else {
        this.myControl.enable();
      }
      this.initFilter();
    }
  }

  private _filter(value: any): string[] {
    if (!value) {
      return this.options;
    }
    const filterValue = value.name ? value.name.toLowerCase() : value;
    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  onOptionSelect() {
    this.value = this.myControl.value;
    this.optionSelected.emit(this.myControl.value);
  }

  displayFn(item: any): string {
    return item && item.name ? item.name : '';
  }
}
